import { SocketMapObservationStats } from 'src_common/common/mobx-utils/Socket/SocketMapObservationStats';

export type SocketSubscriptionMapStats = {
    event: SocketMapObservationStats;
    market: SocketMapObservationStats;
    selection: SocketMapObservationStats;
    eventMarkets: SocketMapObservationStats;
    eventMarketsAll: SocketMapObservationStats;
    sport: SocketMapObservationStats;
    eventQuery: SocketMapObservationStats;
    competition: SocketMapObservationStats;
    rabMarkets: SocketMapObservationStats;
};

export type SocketSubscriptionDebugSnapshot = {
    connection: {
        holderCount: number;
        isConnected: boolean;
    };
    maps: SocketSubscriptionMapStats;
    /** Sum of `active` for maps that send SubscriptionValue on the wire (excludes selection cache). */
    wireActiveSubscriptions: number;
    /** Sum of `total` cache entries for those same maps. */
    wireCacheEntries: number;
};

export const sumWireActiveSubscriptions = (maps: SocketSubscriptionMapStats): number => {
    return (
        maps.event.active +
        maps.market.active +
        maps.eventMarkets.active +
        maps.eventMarketsAll.active +
        maps.sport.active +
        maps.eventQuery.active +
        maps.competition.active +
        maps.rabMarkets.active
    );
};

export const sumWireCacheEntries = (maps: SocketSubscriptionMapStats): number => {
    return (
        maps.event.total +
        maps.market.total +
        maps.eventMarkets.total +
        maps.eventMarketsAll.total +
        maps.sport.total +
        maps.eventQuery.total +
        maps.competition.total +
        maps.rabMarkets.total
    );
};
